import { Grid } from '@mui/material';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../../contexts/cancellation.context';
import { setCookie } from '../../../../utils/generaFunctions';

const Paused = () => {
    const {userInfo, cancelInfo, setLoading} = useContext(CancelContext);
    useEffect(()=>{
        setLoading(false);
        setCookie("cancellation-"+userInfo.email,"yes", 1/12);
    })
    return (
        <Grid container className='confirmed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>OK! We hit the PAUSE<br/>button for you</h1>
                </Grid>
                <Grid item className='small-header'>
                Your next payment date will be on {cancelInfo.renew_date}
                </Grid>
                <Grid item className='body-book' >
                    You can reactivate earlier at any time by reaching<br/>out to us at <a className='body-black' href="mailto:support+cancel@tumtomom.com">support@tumtomom.com</a>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Paused;